module.exports = __webpack_public_path__ + "589c5ca258fecc0dcec511b3a9aae036.jpg";